<template>
  <div
    ref="menu"
    v-if="! $store.getters['settingsModule/elementSidebar']"
    :class="positionClasses"
    class="wf--ml-48 wf-absolute wf-bg-white wf-rounded-lg wf-overflow-hidden wf-border-4 wf-border-white wf-shadow-md wf-w-56 wf-z-50"
  >
    <ul>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="content"
        title="Content"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in contentProperties"
            :key="property.krey"
            :is="property.component"
            :text="property.text"
            :property="property.property"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="style"
        title="Style"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in styleProperties"
            :key="property.key"
            :only="property.only"
            :except="property.except"
            :classes="property.class"
            :is="property.component"
            :element="element"
            :module="module"
          ></component>
        </template>
      </EditorElementMenuList>
      <EditorElementMenuList
        @updateOpen="updateOpen"
        trigger="advanced"
        title="Advanced"
        :open="open"
      >
        <template slot="list">
          <component
            v-for="property in advancedProperties"
            :key="property.key"
            :is="property.component"
            :element="element"
          ></component>
        </template>
      </EditorElementMenuList>
    </ul>
  </div>
</template>

<script>
  import ElementMenu from '../../contracts/ElementMenu'
  export default ElementMenu.extend({
    data() {
      return {
        open: 'content',
      }
    },
    computed: {
      styleProperties() {
        return this.parent.properties.styles
      },
      contentProperties() {
        return this.parent.properties.content
        // let properties = Array.from(window.config.contentProperties[this.family])
        // if (this.srcType == 'external') {
        //   properties.push({key:'text-content', component:'ContentText', text:'source link', property:'srcLink'})
        // }
        // properties.push({key:'click-content', component:'ContentClickAction'})
        // if (this.clickAction == 'external_link') {
        //   properties.push({key:'text-content', component:'ContentText', text:'external link', property:'link'})
        // }
        // return properties
      },
      advancedProperties() {
        return this.parent.properties.advanced
      },
      srcType() {
        return this.parent.srcType
      },
      clickAction() {
        return this.parent.clickAction
      },
    }
  })
</script>